module.exports = __webpack_public_path__ + "img/partner-4.b56c7679.png";